// tabs — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through

export const styles = `
  :host {
    display: flex;
    flex-direction: column;
  }
  :host([orientation="vertical"]) {
    flex-direction: row;
  }
  [part="base"] {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  :host([orientation="vertical"]) [part="base"] {
    flex-direction: row;
  }
  [part="tablist-container"] {
    display: flex;
    flex-direction: row;
    border-bottom: 1px dashed var(--run-wf-border);
    gap: var(--run-tabs-gap, 0);
  }
  :host([orientation="vertical"]) [part="tablist-container"] {
    flex-direction: column;
    border-bottom: none;
    border-inline-end: 1px dashed var(--run-wf-border);
  }
  [part="panel-region"] {
    flex: 1;
  }
  [part="fade-start"],
  [part="fade-end"] {
    display: none;
    pointer-events: none;
    position: absolute;
  }
  :host([scrollable]) [part="tablist-container"] {
    overflow-x: auto;
    scrollbar-width: none;
    position: relative;
  }
  :host([scrollable][orientation="vertical"]) [part="tablist-container"] {
    overflow-x: unset;
    overflow-y: auto;
  }
  :host([scrollable]) [part="fade-start"],
  :host([scrollable]) [part="fade-end"] {
    display: block;
  }
`;

export function render(host) {
  const { orientation, scrollable } = host;
  const fadeAffordances = scrollable
    ? `<div part="fade-start" aria-hidden="true"></div>
       <div part="fade-end" aria-hidden="true"></div>`
    : '';
  host.shadowRoot.innerHTML = `
    <div part="base" class="run-tabs__base">
      <run-box part="tablist-container" role="tablist" aria-orientation="${orientation === 'vertical' ? 'vertical' : 'horizontal'}">
      </run-box>
      <div part="panel-region">
      </div>
      <slot></slot>
      ${fadeAffordances}
    </div>
  `;
}